import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import PageNotFound from './views/PageNotFound.vue'

Vue.use(Router)

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

export default new Router({
  mode: 'hash',
  base: '/socio/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      meta: { auth: true },
      component: () => import('./views/Home.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/recuperar',
      name: 'recuperar',
      component: () => import('./views/Recuperar.vue')
    },
    {
      path: '/redefinir/:token',
      name: 'redefinir',
      component: () => import('./views/Redefinir.vue')
    },
    {
      path: '/informacoes',
      name: 'informacoes',
      meta: { auth: true },
      component: () => import('./views/Informacoes.vue')
    },
    {
      path: '/senha',
      name: 'senha',
      meta: { auth: true },
      component: () => import('./views/Senha.vue')
    },
    { 
      path: '*', 
      component: PageNotFound 
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
